module.exports = __webpack_public_path__ + "static/media/logo_lastfm.ddf47e2b.svg";